exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-thumbnail-source[data-v-47abd3bd] {\n  border-radius: 1.1em;\n}", ""]);

// exports
